import React, { Component } from "react";
import { classNames } from "primereact/utils";

const sizeClasses = {
    sm: "w-2 h-2",
    md: "w-2.5 h-2.5",
};

interface LoadingDotsProps {
    size?: "sm" | "md";
    className?: string;
}

export default class LoadingDots extends Component<LoadingDotsProps> {
    render() {
        const { size = "sm", className } = this.props;
        const dotClass = sizeClasses[size];
        return (
            <div className={classNames("flex justify-center py-4", className)}>
                <div className="flex gap-1.5">
                    <div className={classNames(dotClass, "rounded-full bg-primary-600 dark:bg-primary-400 animate-pulse")} style={{ animationDelay: "0ms" }} />
                    <div className={classNames(dotClass, "rounded-full bg-primary-600 dark:bg-primary-400 animate-pulse")} style={{ animationDelay: "150ms" }} />
                    <div className={classNames(dotClass, "rounded-full bg-primary-600 dark:bg-primary-400 animate-pulse")} style={{ animationDelay: "300ms" }} />
                </div>
            </div>
        );
    }
}
